angular.module('qkr.refund').controller('refundController', ($scope, messageService, gettextCatalog, transService,
                                                             refundService, _, refundListInitData, $log) => {
    $scope.transactions = refundListInitData.transactions;
    $scope.totalValue = refundListInitData.totalValue;
    $scope.totalOriginalValue = refundListInitData.totalOriginalValue;
    $scope.totalRefundedValue = refundListInitData.totalRefundedValue;
    $scope.isSchoolLike = refundListInitData.isSchoolLike;
    if ($scope.isSchoolLike) transService.sortSchoolTrans($scope.transactions);
    $scope.allowPartial = refundListInitData.allowPartial;
    $scope.merchant = refundListInitData.merchant;
    $scope.isLoading = false;

    $scope.listTransCommand = {
        allTransactions: false,
        startDate: new Date(),
        endDate: new Date(),
        ourRef: null,
        name: null
    };
    const getTransactions = function(listTransCommand) {
        const openTransIds = _.map($scope.transactions, (transaction) => {
            if (transaction.isOpen !== undefined && transaction.isOpen === true) {
                return transaction.id;
            }
        });

        transService.listTransactions(listTransCommand)
            .then((response) => {
                $scope.transactions = response.transactions;
                $scope.totalValue = response.totalValue;
                $scope.totalOriginalValue = response.totalOriginalValue;
                $scope.totalRefundedValue = response.totalRefundedValue;

                angular.forEach(openTransIds, (transId) => {
                    if (transId) {
                        const trans = $scope.transactions.find(t => t.id === transId);

                        if (trans) {
                            trans.isOpen = true;
                        }
                    }
                });
                $scope.isLoading = false;
            }).catch(reason => $log.error(reason));
    };

    $scope.refundTrans = function(refundTransaction) {
        const transIndex = $scope.transactions.indexOf(refundTransaction);
        const modal = refundService.openTransRefundModal(refundTransaction);

        modal.result
            .then((result) => {
                if (result.message && result.message === 'ok') {
                    $scope.transactions[transIndex] = result.refundedTransaction;
                    $scope.transactions[transIndex].isOpen = true;

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                }
            }).catch(reason => $log.error(reason));
    };

    $scope.refundTransItem = function(refundTrans, refundTransItem) {
        const transIndex = $scope.transactions.indexOf(refundTrans);
        const modal = refundService.openTransItemRefundModal(refundTrans, refundTransItem);

        modal.result.then((result) => {
            if (result.message && result.message === 'ok') {
                $scope.transactions[transIndex] = result.refundedTransaction;
                $scope.transactions[transIndex].isOpen = true;

                if (!$scope.$$phase) {
                    $scope.$apply();
                }

                $scope.search();
            }
        }).catch(reason => $log.error(reason));
    };

    $scope.search = function() {
        $scope.isLoading = true;
        const listTransCommand = angular.copy($scope.listTransCommand);

        if (listTransCommand.allTransactions) {
            listTransCommand.startDate = null;
            listTransCommand.endDate = null;
        } else {
            listTransCommand.startDate = listTransCommand.startDate ? listTransCommand.startDate.getTime() : null;
            listTransCommand.endDate = listTransCommand.endDate ? listTransCommand.endDate.getTime() : null;
        }

        if (!listTransCommand.startDate && !listTransCommand.endDate &&
            !listTransCommand.allTransactions && !listTransCommand.ourRef &&
            !listTransCommand.name) {
            messageService.errorWithReason(gettextCatalog.getString('Please enter at least 1 field'), '', true);
            return;
        }

        getTransactions(listTransCommand);
    };

    $scope.showHistory = function(trans) {
        refundService.openTransRefundHistoryModal(trans);
    };

    $scope.showRefundAll = function(transaction) {
        if (transaction.fullyRefunded) {
            return false;
        }

        // Schools requirement - Refund is disabled if item is in a non-cancellable menu (date-related but with
        // cancelForbidden set), will need to do a partial refund on each refundable item
        if ($scope.isSchoolLike && ( _.where(transaction.transItems, {partialRefundDisabled: true}).length > 0 ||
            transaction.creditUsed)) {
            return false;
        }

        // 'totalBeforeCancelledItems' is only set if an item is cancelled from a transaction
        if($scope.isSchoolLike && transaction.totalBeforeCancelledItems) {
            return false;
        }

        // If there is no transaction item, yet the transaction is not fully refunded
        if (_.isUndefined(transaction.transItems)
            || _.isNull(transaction.transItems)
            || _.isEmpty(transaction.transItems)) {
            return true;
        }

        // If there is only one item that isn't refunded then hide the button, need to just do a partial on that one
        if (_.where(transaction.transItems, {fullyRefunded: false}).length === 1 || _.where(transaction.transItems,
                {fullyRefunded: undefined}).length === 1) {
            if ($scope.isSchoolLike) {
                return true;
            }

            if (!$scope.allowPartial) {
                return true;
            }

            return false;
        }

        return true;
    };

    $scope.showPartial = function(trans, transItem) {
        if (!$scope.allowPartial) {
            return false;
        }

        // Partial refund not supported if coupon or credit note was used
        if (trans.partialRefundDisabled) {
            return false;
        }

        if (transItem.fullyRefunded) {
            return false;
        }

        if (transItem.partialRefundDisabled) {
            return false;
        }

        return true;
    };



    $scope.dateOptions = {
        startDateOpen: false,
        endDateOpen: false,
        maxDate: new Date()
    };
});



// WEBPACK FOOTER //
// ./src/refund/controllers/refund.controller.js